import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { ScopedEntity } from '../../ScopedEntity.js';
import { CampusArea } from './CampusSection.js';

@Entity()
export class CampusEvent extends ScopedEntity {
  public static override _class = 'CampusEvent';
  public static override _collectionName = 'campus-events';

  public static override get allFields() {
    return selectionSet(() => this, 2);
  }

  @validate(nonOptional())
  @Field(() => String)
  public title: Maybe<string>;

  @Field(() => String, {
    default: v => v ?? CampusArea.STUDENTS,
  })
  public area: Maybe<string>;

  @validate(nonOptional())
  @Field(() => DateTime)
  public startDate: Maybe<DateTime>;

  @Field(() => DateTime)
  public endDate: Maybe<DateTime>;

  @Field(() => String)
  public description: Maybe<string>;

  @validate(({ value, key, source }) => {
    if (!value || value === '/') throw new ValidationError(`Dies ist ein Pflichtfeld!`, { key, source });
  })
  @Field(() => String, {
    default: v => v ?? '/',
  })
  public urlToEvent: Maybe<string>;

  @Field(() => String, {
    default: v => v ?? '/',
  })
  public urlToModeration: Maybe<string>;

  @Field(() => [Int], {
    default: v => v ?? [],
  })
  public forGrades!: number[];

  @Field(() => [String], {
    default: v => v ?? [],
  })
  public subjects!: string[];
}
